import { __assign, __read } from "tslib";
/**
 * Omits properties that starts with `$` (Styletron)
 * @param $props properties
 */
export var omit$props = function ($props) {
    return Object.entries($props).reduce(function (props, _a) {
        var _b = __read(_a, 2), key = _b[0], val = _b[1];
        if (key[0] !== '$')
            props[key] = val;
        return props;
    }, {});
};
/**
 * Prefixes property names with `$` (Styletron)
 * @param props properties
 */
export var add$props = function (props) {
    return Object.entries(props).reduce(function ($props, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], val = _c[1];
        return (__assign(__assign({}, $props), (_b = {}, _b[key[0] === '$' ? key : "$".concat(key)] = val, _b)));
    }, {});
};
/**
 * Recursively extract css value from css variable value
 * { ui01: 'var(--spr-ui-01, #FFF)' } -> { ui01: '#FFF' }
 *
 * Jest does not recognize css variables, this utility can help convert theme object.
 *
 * @param value
 */
export var covertCSSVariablesToValue = function (value) {
    if (typeof value === 'string' && value.indexOf('var(') >= 0) {
        var startIndex = value.indexOf(',');
        return value.slice(startIndex + 1, value.length - 1).trim();
    }
    if (value && typeof value === 'object') {
        var newValue_1 = {};
        Object.keys(value).forEach(function (key) {
            newValue_1[key] = covertCSSVariablesToValue(value[key]);
        });
        return newValue_1;
    }
    return value;
};
export var themeTokenToHex = function (token) {
    var hex = covertCSSVariablesToValue(token);
    var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    var parsed = hex.replace(shorthandRegex, function (m, r, g, b) {
        return r + r + g + g + b + b;
    });
    return parsed;
};
/**
 * Converts hexadecimal color to RGB or RGBA (if alpha is provided)
 * @param hex hexadecimal color
 * @param alpha opacity
 */
export var hex2rgb = function (_hex, alpha) {
    var hex = covertCSSVariablesToValue(_hex);
    var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    var parsed = hex.replace(shorthandRegex, function (m, r, g, b) {
        return r + r + g + g + b + b;
    });
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(parsed);
    if (result) {
        return alpha
            ? "rgba(".concat(parseInt(result[1], 16), ", ").concat(parseInt(result[2], 16), ", ").concat(parseInt(result[3], 16), ", ").concat(alpha, ")")
            : "rgb(".concat(parseInt(result[1], 16), ", ").concat(parseInt(result[2], 16), ", ").concat(parseInt(result[3], 16), ")");
    }
    return null;
};
